export enum SsoSystem {
    "PZ" = "pz.gov.pl",
    "LOGIN_GOV" = "login.gov.pl"
}
